module.exports = __webpack_public_path__ + "static/media/nose.0559612a.mov";